export default __webpack_public_path__ + "static/media/trampapo_02_25.09a4b58d.jpg";